import styled from 'styled-components'
  const GeofenceBox = styled.div`
  flex: 0 0 100%;
  padding: 1em;
  height: 40px !important;
  margin-right: 120px !important;
  margin-bottom: -190px !important;
  text-align: ${props =>
    props.center ? 'center' : props.align ? props.align : 'left'};
  @media (min-width: 40em) {
    flex: ${props => (props.width ? `0 0 ${props.width}` : 1)};
    width: ${props => (props.width ? props.width : '100%')};
  }
  @media (max-width: 600px) {    
    margin-top: 10px !important;
    margin-right: 0px !important;
    width: 100px;
  }
  /* Moto G4 & Microsoft Lumia 950 & Microsoft Lumia 550 & Galaxy S3 & Galaxy Note 2 & Galaxy Note 3 */
  @media only screen and (device-width: 360px) and (device-height: 640px) {
    margin-top: 10px !important;
    margin-right: 0px !important;
    width: 100px;
  }
  /* Nexus 4 & LG Optimus L70*/
  @media only screen and (device-width: 384px) and (device-height: 640px) {
    margin-top: 10px !important;
    margin-right: 0px !important;
    width: 100px;
  }
  /* Nexus 6 and Nexus 5X*/
  @media only screen and (device-width: 412px) and (device-height: 732px) {
    margin-top: 10px !important;
    margin-right: 0px !important;
    width: 100px;
  }
  @media only screen and (device-width: 540px) and (device-height: 960px) {
    margin-top: 10px !important;
    margin-right: 0px !important;
    width: 100px;
  }
  /* Nexus 7*/
  @media only screen and (device-width: 600px) and (device-height: 960px) {
    margin-top: 10px !important;
    margin-right: 0px !important;
    width: 100px;
  }
  `;

export default GeofenceBox